import { parseNumber } from '../../utils/number.utils';
import { UserNotifications } from '../user-notifications';
import { UserNotificationBuilder } from './user-notification.builder';

export class UserNotificationsBuilder {
  static fromJson(json) {
    return (json)
      ? new UserNotifications(
        UserNotificationBuilder.fromList(json.userNotifications),
        parseNumber(json.totalPage),
        parseNumber(json.total)
      )
      : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-notifications.builder.ts